<template>
  <div class="qrcode-scan">
    <div class="qrcode-scan-img">
      <img :src="qrcode" alt />
    </div>
    <div class="qrcode-scan-box" v-if="!show && !isShow">
      <div class="qrcode-scan-box-title">请填写党员报到相关信息</div>
      <div class="qrcode-scan-box-template" v-for="(data,i) in templateArr" :key="i">
        <p>
          <span style="color:red">*</span>
          {{data.name}}
        </p>
        <input :type="data.type" v-model="data.value" />
      </div>

      <div class="qrcode-scan-box-sumbit" @click="sumbit()">
        <button>确认提交</button>
      </div>
    </div>
    <div v-show="isShow" class="isShow">
        <div class="imgbox">
          <img src="@/assets/partyreports/chengg.png" alt="" />
          提交成功
        </div>
        <div>欢迎回家！</div>
        <div>党员管家稍后跟您联系！</div>
      </div>
    <div class="qrcode-scan-table" v-if="show">
      <p class="qrcode-scan-table-infor">
        查看统计信息 | 总共
        <span style="color:red">{{allArr.length}}</span> 数据
      </p>
      <p class="qrcode-scan-table-shows">
        每页显示
        <el-select v-model="value" placeholder="5" @change="change">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>条
      </p>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="报到人"></el-table-column>
        <el-table-column prop="createtime" label="报到时间"></el-table-column>
        <el-table-column prop="operating" label="操作">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="handleClick(scope.$index, tableData)"
              type="text"
              size="small"
            >查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total"
        @next-click="nextClick"
        @prev-click="prevClick"
        @current-change="currentChange"
      ></el-pagination>
    </div>

    <div class="qrcode-scan-module" @click="hide" v-show="motaiShow">
      <div class="qrcode-scan-module-box" @click.stop>
        <div class="qrcode-scan-module-box-title">党员报到信息详情</div>
        <div class="qrcode-scan-module-box-template" v-for="(data,i) in detailArr" :key="i">
          <p>
            <span style="color:red">*</span>
            {{data.name}}
          </p>
          <p class="qrcode-scan-module-box-template-content">{{data.value}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      qrcode:
        sessionStorage.getItem("id") == "26842"
          ? require("@/assets/outSide/dp-sy-lm4.png")
          : require("@/assets/outSide/dp-sy-lm3.png"),
      templateArr: [
        { name: "姓名", type: "text", value: "" },
        { name: "身份证号", type: "text", value: "" },
        { name: "手机号码", type: "number", value: "" },
        { name: "公司名称", type: "text", value: "" },
        { name: "现党组织关系", type: "text", value: "" },
        { name: "现党组织关系所在地", type: "text", value: "" },
        { name: "现党组织关系电话号码", type: "text", value: "" }
      ],
      show: sessionStorage.getItem("id") == "26842" ? true : false,
      tableData: [],
      options: [
        {
          value: 5,
          label: 5
        },
        {
          value: 10,
          label: 10
        }
      ],
      value: 5,
      total: 10,
      motaiShow: false,
      allArr: [],
      detail: {},
      detailArr: [
        { name: "姓名", type: "text", value: "" },
        { name: "身份证号", type: "text", value: "" },
        { name: "手机号码", type: "number", value: "" },
        { name: "公司名称", type: "text", value: "" },
        { name: "现党组织关系", type: "text", value: "" },
        { name: "现党组织关系所在地", type: "text", value: "" },
        { name: "现党组织关系电话号码", type: "text", value: "" }
      ],
      currenPage:1,
      isShow: false
    };
  },
  mounted() {
    if (sessionStorage.getItem("id") == "26842") {
      this.getList();
    }
    console.log(this.allArr);
  },
  methods: {
    currentChange(e) {
      this.currenPage = e
      this.tableData = [];
      for (let x = 0; x < this.allArr.length; x++) {
        if (x < e * this.value && x >= (e - 1) * this.value) {
          this.tableData.push(this.allArr[x]);
        }
      }
    },
    prevClick(e) {
      this.currenPage = e
      this.tableData = [];
      for (let x = 0; x < this.allArr.length; x++) {
        if (x < e * this.value && x >= (e - 1) * this.value) {
          this.tableData.push(this.allArr[x]);
        }
      }
    },
    nextClick(e) {
      this.currenPage = e
      this.tableData = [];
      for (let x = 0; x < this.allArr.length; x++) {
        if (x < e * this.value && x >= (e - 1) * this.value) {
          this.tableData.push(this.allArr[x]);
        }
      }
    },
    sumbit() {
      let name = this.templateArr.some(item => {
        if (item.value == "") {
          this.$message({
            message: item.name + "为空",
            type: "error",
            offset: 300,
            duration: 1000
          });
          return true;
        }

        if (item.name == "身份证号") {
          let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (reg.test(item.value) === false) {
            this.$message({
              message: "身份证输入不合法",
              type: "error",
              offset: 300,
              duration: 1000
            });
            return true;
          }
        }

        if (item.name == "手机号码") {
          if (!/^1[3456789]\d{9}$/.test(item.value)) {
            this.$message({
              message: "手机号输入有误",
              type: "error",
              offset: 300,
              duration: 1000
            });
            return true;
          }
        }
      });
      if (!name) {
        let data = {
          name: this.templateArr[0].value,
          idCard: this.templateArr[1].value,
          phone: this.templateArr[2].value,
          companyName: this.templateArr[3].value,
          partyOrganization: this.templateArr[4].value,
          location: this.templateArr[5].value,
          partyPhone: this.templateArr[6].value,
          typename:'财富中心综合党委'
        };
        this.axios.post("/api/Main/AddInformation", data).then(e => {
          if (e.data.code == 0) {
            // this.$message({
            //   message: "提交成功",
            //   type: "success",
            //   offset: 300,
            //   duration: 1000
            // });
            this.isShow = true;
            sessionStorage.setItem("token", "61633105-5ea4-49d9-82de-869f1be7ca23");
            sessionStorage.setItem('roleid',6)
            sessionStorage.setItem('name','游客')
            // this.$router.push("/index");
          } else {
            this.$message({
              // message: "提交失败,请稍后重试",
              message: res.data.msg || "提交失败,请稍后重试",
              type: "error",
              offset: 300,
              duration: 1000
            });
          }
        });
      }
    },
    handleClick(m, n) {
      this.axios(`/api/Main/InformationId?id=${n[m].id}`).then(e => {
        if (e.data.code == 0) {
          this.detail = e.data.msg;
          this.detailArr[0].value = this.detail.name;
          this.detailArr[1].value = this.detail.idCard;
          this.detailArr[2].value = this.detail.phone;
          this.detailArr[3].value = this.detail.companyName;
          this.detailArr[4].value = this.detail.partyOrganization;
          this.detailArr[5].value = this.detail.location;
          this.detailArr[6].value = this.detail.partyPhone;
        }
      });
      this.motaiShow = true;
    },
    change(e) {
      this.total = Math.ceil(this.allArr.length / e) * 10;
      this.tableData = [];
      for (let x = 0; x < this.allArr.length; x++) {
        if (x < this.currenPage * this.value && x >= (this.currenPage - 1) * this.value) {
          this.tableData.push(this.allArr[x]);
        }
      }
    },
    hide() {
      this.motaiShow = false;
    },
    getList() {
      this.axios.get("/api/Main/InformationList").then(e => {
        if (e.data.code == 0) {
          // this.allArr = e.data.msg
          e.data.msg.filter(item => {
            this.allArr.push({
              name: item.name,
              createtime: item.createtime ? item.createtime.split("T")[0] : "",
              id: item.id,
              operating: "查看详情"
            });
          });
          this.total = Math.ceil(this.allArr.length / this.value) * 10;
          for (let x = 0; x < this.allArr.length; x++) {
            if (x < this.value) {
              this.tableData.push(this.allArr[x]);
            }
          }
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.qrcode-scan {
  &-module {
    &-box {
      &-template {
        &-content {
          width: 100%;
          border-radius: 0.1rem;
          padding: 0.2rem;
          border: none;
          background: #f4f4f4;
          margin-top: 0.1rem;
        }
        font-size: 0.32rem;
        margin-top: 0.3rem;
      }
      &-title {
        font-weight: bold;
        line-height: 2;
      }
      width: 94%;
      left: 3%;
      padding: 0.4rem;
      background: #fff;
      position: absolute;
      box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
      top: 2rem;
      border-radius: 0.1rem;
      height: 80vh;
      overflow-y: scroll;
    }
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
  }
  &-table {
    &-shows {
      .el-select {
        width: 1.5rem;
      }
      font-size: 0.24rem;
      margin: 0.3rem 0;
    }
    &-infor {
      font-size: 0.24rem;
    }
    width: 94%;
    left: 3%;
    padding: 0.4rem;
    background: #fff;
    position: absolute;
    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    top: 3.4rem;
    border-radius: 0.1rem;
  }
  &-box {
    &-sumbit {
      button {
        width: 4.6rem;
        height: 0.76rem;
        background: linear-gradient(
          -70deg,
          rgba(254, 123, 73, 1) 0%,
          rgba(250, 112, 91, 1) 100%
        );
        box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
        border-radius: 0.08rem;
        border: none;
        color: #fff;
      }
      text-align: center;
      margin-top: 1rem;
    }
    &-template {
      input {
        width: 100%;
        border-radius: 0.1rem;
        padding: 0.2rem;
        border: none;
        background: #f4f4f4;
        margin-top: 0.1rem;
      }
      font-size: 0.32rem;
      margin-top: 0.3rem;
    }
    &-title {
      font-weight: bold;
      line-height: 2;
    }
    width: 94%;
    left: 3%;
    padding: 0.4rem;
    background: #fff;
    position: absolute;
    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    top: 3.4rem;
    border-radius: 0.1rem;
  }
  &-img {
    img {
      width: 100%;
    }
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 1rem;
  font-size: 0.3rem;
}
.isShow {
    .imgbox {
      img {
        width: 2.35rem;
        height: 2.29rem;
      }
      width: 2.35rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: #ff562f;
      text-align: center;
      margin: 0 auto 0.56rem;
    }
    > div:nth-of-type(2) {
      font-size: 0.46rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: 0.2rem;
    }
    > div:nth-of-type(3) {
      font-size: 0.46rem;
      font-weight: 400;
      color: #333333;
    }
    text-align: center;
    padding: 0.84rem 0 3rem;
    background: #fff;
    position: fixed;
    width: 90%;
    top: 3.54rem;
  }
</style>